import React from "react"
import { Trans, useTranslation } from "react-i18next"
import * as Components from "../../components/components"
import { ALLOWED_FILE_EXTENSIONS, MAX_FILESIZE_MB } from "../../constants"
import { EventBus } from "../../eventbus"
import { UploadAnlage } from "../../models/uploadanlage"

interface UploadAnlageViewProps {
    index: number
    anlage: UploadAnlage
}

export function UploadAnlageView(props: UploadAnlageViewProps) {
    const { t } = useTranslation()

    const renderFileInfo = (anlage: UploadAnlage) => {
        const children = []

        if (anlage.dateiError === "file-too-big") {
            children.push(
                <p key="1" className="text-danger">
                    <Trans t={t} i18nKey="rechnung.anlagen.dateiAnlage.uploadFehler.dateiZuGross" values={{ maximaleDateigroesse: MAX_FILESIZE_MB }} />
                </p>,
            )
        } else if (anlage.dateiError === "unsupported-extension") {
            children.push(
                <p key="1" className="text-danger">
                    {t("rechnung.anlagen.dateiAnlage.uploadFehler.dateitypeNichtUnterschtuetzt")}
                    <br />
                    {ALLOWED_FILE_EXTENSIONS.map((extension) => extension.toUpperCase()).join(", ")}.
                </p>,
            )
        }

        if (anlage.notEmpty) {
            children.push(
                <p key="2">
                    {anlage.datei?.name} &ndash; {anlage.datei?.type} &ndash; {anlage.datei?.size} Bytes
                </p>,
            )
        } else {
            children.push(
                <p key="3" className="text-warning">
                    {t("rechnung.anlagen.dateiAnlage.uploadFehler.keineDatei")}
                </p>,
            )
        }

        return <div className="small">{children}</div>
    }

    return (
        <Components.Row>
            <Components.Col size={8}>{renderFileInfo(props.anlage)}</Components.Col>

            <Components.Col size={4} align={Components.Align.RIGHT}>
                <Components.FilePicker
                    t={t}
                    onFileSelected={(errorReason, file) => {
                        EventBus.instance.emit("changeProperty", `anlagen.${props.index}.name`, file?.name || "")
                        EventBus.instance.emit("changeProperty", `anlagen.${props.index}.datei`, file)
                        EventBus.instance.emit("changeProperty", `anlagen.${props.index}.dateiError`, errorReason)
                    }}
                />
            </Components.Col>
        </Components.Row>
    )
}
